<template lang="pug">
  .swap-vehicle-asset
    a.button.small(@click="swapEnabled = !swapEnabled") Swap
    .content(v-if="swapEnabled")
      .close-button(@click="swapEnabled = false") x
      h2 VS{{item.id}}
      p Select the destination from the dropdown list
      selectize-vehicle-slot(@optionSelected="selected")
      button.button(:class="{disabled:!itemSelected}", @click="processSwap") Confirm
</template>

<script>
  import ModalReveal from '../../../foundation/ModalReveal'
  import SelectizeVehicleSlot from '../../lists/selectize/SelectizeVehicleSlot'

  export default {
    name: 'SwapAsset',
    components: {SelectizeVehicleSlot, ModalReveal},
    data: function () {
      return {
        swapEnabled: false
      }
    },
    props: ['item', 'itemList'],
    methods: {
      selected(item) {
        this.itemSelected = item.id
      },
      processSwap() {
        this.$emit('processSwap', this.itemSelected)
        this.swapEnabled = false
      }
    }

  }
</script>

<style lang="sass">
  .swap-vehicle-asset
    .content
      display: flex
      justify-content: center
      flex-direction: column
      height: 100%
      position: absolute
      top: 0
      left: 0
      right: 0
      background: white
      z-index: 1
</style>



// WEBPACK FOOTER //
// SwapAsset.vue?266315f6